/** Fixed Eastern Standard Time (UTC-5). */
const EST_TIME_ZONE = 'Etc/GMT+5';

function parseUtcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const text = String(value).trim();
  if (!text) return null;
  if (text.includes('T')) {
    const parsed = new Date(text);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  const parsed = new Date(`${text.replace(' ', 'T')}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateTimeEST(value, { fallback = 'Never' } = {}) {
  const date = parseUtcDate(value);
  if (!date) return fallback;

  return date.toLocaleString('en-US', {
    timeZone: EST_TIME_ZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });
}